<template>
  <v-app>
    <v-main class="login-shell">
      <router-view />
    </v-main>
  </v-app>
</template>

<style scoped>
.login-shell {
  min-height: 100vh;
  background: #f7f8fa;
}
</style>
